<app-teranet-no-pin *ngIf="!primary"></app-teranet-no-pin>

<div *ngIf="primary">
	<div class="sticky top-0 bg-white z-20 py-4 border-b">
		<h4 class="mr-2">Instruments | PIN: {{ selectedPin?.pin }}</h4>
		<div class="flex flex-1 justify-between items-center">
			<div class="flex gap-3 item-center">
				<ui-button
					size="sm"
					preset="HIGH_EMPHASIS"
					icon="currency-dollar"
					label="Purchase selected ({{ selectedCount }})"
					teranetLoginGuard
					[disabled]="selectedCount === 0"
					(click)="purchaseSelected()"
					[testHook]="testHooks.PurchaseSelectedButton"
				></ui-button>
				<ui-button
					*ngIf="showFetchDocuments"
					size="sm"
					label="Search Documents"
					class="ml-3"
					teranetLoginGuard
					[loading]="searching"
					(click)="searchDocuments()"
					[testHook]="testHooks.SearchDocumentsButton"
				></ui-button>
				<ui-button
					size="sm"
					icon="plus"
					preset="EXTRA_LOW_EMPHASIS"
					label="Add Instrument"
					(click)="addInstrument()"
					[testHook]="testHooks.AddInstrumentButton"
				></ui-button>
			</div>
			<div class="flex items-center">
				<app-checkbox
					type="clear"
					[ngClass]="filterItems.length > 0 && 'pr-10 border-r'"
					[ngModel]="showDeleted"
					(ngModelChange)="toggleShowDeleted($event)"
					[label]="'Show deleted instruments'"
					[testHook]="testHooks.ShowDeletedCheckbox"
				></app-checkbox>
				<div class="flex items-center pl-10">
					<app-radio-group
						[items]="filterItems"
						[ngModel]="_typeFilter"
						(ngModelChange)="setType($event)"
						type="compact"
						[testHook]="testHooks.TypeFilterRadioGroup"
					></app-radio-group>
				</div>
			</div>
		</div>
	</div>

	<div class="mt-5">
		<table
			mat-table
			multiTemplateDataRows
			[dataSource]="dataSource"
			matSort
			class="dashboard-table table-auto w-full border border-grey-lighter rounded-xl text-lg sticky-header-offset"
			(matSortChange)="onSortChange($event)"
		>
			<ng-container matColumnDef="exclamation">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let element">
					<app-icon
						[icon]="ICON.EXCLAMATION"
						[matTooltip]="instrumentPurchaseState[element?.reg_number]?.error"
						*ngIf="instrumentPurchaseState[element?.reg_number]?.error"
						class="text-red"
						[testHook]="testHooks.ExclamationIcon"
					></app-icon>
				</td>
			</ng-container>

			<ng-container matColumnDef="state">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let element">
					<div *ngIf="pin?.parcels?.length > 1">
						<app-icon
							*ngIf="element?.state === state.SAME"
							[icon]="ICON.CHECK"
							matTooltip="All instruments match across all parcels"
							[testHook]="testHooks.CheckIcon"
						></app-icon>
						<app-icon
							*ngIf="element?.state === state.ADD"
							[icon]="ICON.ADD"
							matTooltip="New instruments that have been added since the original parcel"
							[testHook]="testHooks.AddIcon"
						></app-icon>
						<app-icon
							*ngIf="element?.state === state.MINUS"
							[icon]="ICON.MINUS"
							matTooltip="Instruments have been deleted from the original parcel"
							[testHook]="testHooks.MinusIcon"
						></app-icon>
					</div>
				</td>
			</ng-container>
			<ng-container matColumnDef="fileIcon">
				<th mat-header-cell *matHeaderCellDef>
					<app-checkbox
						type="clear"
						[ngModel]="selectAll"
						[disabled]="!dataSource?.data?.length"
						(ngModelChange)="toggleAllInstruments($event)"
						[testHook]="testHooks.SelectAllCheckbox"
					></app-checkbox>
				</th>
				<td mat-cell *matCellDef="let element">
					<app-checkbox
						*ngIf="
							!element?.saved?.uploaded_document_path &&
							instrumentPurchaseState[element?.reg_number]?.state !==
								purchaseState.PURCHASING
						"
						class="cursor-pointer"
						type="clear"
						[ngModel]="selectedInstruments[element?.reg_number]"
						(ngModelChange)="toggleSelectedInstrument($event, element)"
						[testHook]="testHooks.ToggleSelectedInstrumentCheckbox"
					></app-checkbox>
					<app-icon
						*ngIf="element?.saved?.uploaded_document_path"
						[icon]="ICON.PDF"
						(click)="
							showInstrumentPDF(
								element.saved.uploaded_document_path,
								element?.reg_number,
								element?.type
							)
						"
						class="cursor-pointer text-red-darker text-2xl"
						[testHook]="testHooks.PdfIcon"
					></app-icon>
					<app-icon
						*ngIf="
							instrumentPurchaseState[element?.reg_number]?.state ===
								purchaseState.PURCHASING &&
							!element?.saved?.uploaded_document_path
						"
						[icon]="ICON.LOADING"
						[spin]="true"
						[testHook]="testHooks.LoadingIcon"
					></app-icon>
				</td>
			</ng-container>

			<ng-container matColumnDef="reg_number">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
				<td mat-cell *matCellDef="let element">{{ element.reg_number }}</td>
			</ng-container>

			<ng-container matColumnDef="reg_date">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
				<td mat-cell *matCellDef="let element">{{ element.reg_date }}</td>
			</ng-container>

			<ng-container matColumnDef="type">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
				<td mat-cell *matCellDef="let element">{{ element.type }}</td>
			</ng-container>

			<ng-container matColumnDef="from">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
				<td mat-cell *matCellDef="let element">
					<span
						*ngFor="let from of element.parties_from; index as i"
						[ngClass]="{
							'bg-green-300': element?.sameNamesFromIndexes?.includes(i),
						}"
						class="mr-3"
					>
						{{ from | capitalize }}
						<app-icon
							*ngIf="element?.sameNamesFromIndexes?.includes(i)"
							matTooltip="Common Names Detected"
							class="text-lg text-gray-400 ml-3"
							[icon]="ICON.PARTIES"
							[testHook]="testHooks.PartiesIcon"
						></app-icon>
					</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="to">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>To</th>
				<td mat-cell *matCellDef="let element">
					<span
						*ngFor="let to of element.parties_to; index as i"
						[ngClass]="{
							'bg-green-300': element?.sameNamesToIndexes?.includes(i),
						}"
						class="mr-3"
					>
						{{ to | capitalize }}
						<app-icon
							*ngIf="element?.sameNamesToIndexes?.includes(i)"
							matTooltip="Common Names Detected"
							class="text-lg text-gray-400 ml-3"
							[icon]="ICON.PARTIES"
							[testHook]="testHooks.PartiesIcon1"
						></app-icon>
					</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="status">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
				<td mat-cell *matCellDef="let element">{{ element?.status }}</td>
			</ng-container>

			<ng-container matColumnDef="amount">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
				<td mat-cell *matCellDef="let element">{{ element?.amount }}</td>
			</ng-container>

			<ng-container matColumnDef="showEncumbrance">
				<th mat-header-cell *matHeaderCellDef mat-sort-header></th>
				<td mat-cell *matCellDef="let element">
					<div *ngIf="fileType === matterFileTypes.PURCHASE">
						<ui-button
							size="sm"
							*ngIf="requisitionsInstrumentNumbers.has(element.reg_number)"
							(click)="editRequisition(element)"
							preset="EXTRA_LOW_EMPHASIS"
							icon="edit"
							label="Edit Requisition"
							[testHook]="testHooks.EditRequisitionButton"
						>
						</ui-button>
						<ui-button
							*ngIf="!requisitionsInstrumentNumbers.has(element.reg_number)"
							size="sm"
							label="Add Requisition"
							preset="MEDIUM_EMPHASIS"
							icon="plus"
							(click)="addRequisition(element)"
							[testHook]="testHooks.AddRequisitionButton"
						></ui-button>
					</div>
					<div *ngIf="element.showEncumbrance" class="flex justify-end px-3">
						<ui-button
							*ngIf="
								!element?.encumbranceUrl &&
								fileType !== matterFileTypes.PURCHASE
							"
							size="sm"
							label="Add Encumbrance"
							(click)="addEncumbrance(element)"
							preset="MEDIUM_EMPHASIS"
							icon="plus"
							[testHook]="testHooks.AddEncumbranceButton"
						></ui-button>
						<app-anchor
							size="small"
							class="whitespace-nowrap"
							*ngIf="element?.encumbranceUrl"
							[url]="element.encumbranceUrl"
							type="static"
							[queryParams]="{ 'back-string': 'title search' }"
							[testHook]="testHooks.ViewEncumbranceLink"
							>View encumbrance</app-anchor
						>
					</div>
				</td>
			</ng-container>

			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell text-center text-grey" colspan="9999">
					No instruments
				</td>
			</tr>

			<tr
				mat-header-row
				*matHeaderRowDef="displayColumns; sticky: true"
				class="sticky-header"
			></tr>
			<tr
				mat-row
				*matRowDef="let row; columns: displayColumns"
				class="cursor-pointer"
			></tr>

			<ng-container matColumnDef="attachments">
				<td
					mat-cell
					*matCellDef="let element"
					[attr.colspan]="displayColumns.length"
					class="w-full"
				>
					<table class="ml-40">
						<tr
							*ngFor="let attachment of element.saved?.attachments | keyvalue"
						>
							<td>
								<app-checkbox
									*ngIf="
										!attachment?.value?.uploaded_document_path &&
										attachmentsPurchaseState[attachment?.value?.document_number]
											?.state !== purchaseState.PURCHASING
									"
									class="cursor-pointer"
									type="clear"
									[ngModel]="
										selectedAttributeItems[attachment?.value?.document_number]
									"
									(ngModelChange)="
										toggleSelectedAttribute($event, element, attachment?.value)
									"
									[testHook]="testHooks.ToggleSelectedAttributeCheckbox"
								></app-checkbox>
								<app-icon
									*ngIf="attachment?.value?.uploaded_document_path"
									[icon]="ICON.PDF"
									(click)="
										showInstrumentPDF(
											attachment?.value?.uploaded_document_path,
											attachment?.value?.reg_number
										)
									"
									class="cursor-pointer text-red-darker text-2xl"
									[testHook]="testHooks.PdfIcon1"
								></app-icon>
								<app-icon
									*ngIf="
										attachmentsPurchaseState[attachment?.value?.document_number]
											?.state === purchaseState.PURCHASING &&
										!attachment?.value?.uploaded_document_path
									"
									[icon]="ICON.LOADING"
									[spin]="true"
									[testHook]="testHooks.LoadingIcon1"
								></app-icon>
							</td>
							<td>
								{{ attachment?.value?.document_name }}
							</td>
							<td>
								{{
									attachment?.value?.price_total
										? '$' + attachment?.value?.price_total
										: ''
								}}
							</td>
						</tr>
					</table>
				</td>
			</ng-container>

			<tr
				mat-row
				*matRowDef="let row; columns: ['attachments']; when: isAnAttachment"
				class="cursor-pointer"
			></tr>
		</table>
	</div>
</div>
